/* eslint-disable react/forbid-prop-types */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { isDirty, reset, isInvalid, reduxForm, getFormValues } from "redux-form";
import * as _ from "lodash";
import ProjectDetails from "../shared/projectDetails/ProjectDetailsContainer";
import { selectProject, mapProjectDataToUI } from "../projectSelectors";
import * as modalActions from "../../_shared/modal/modalActions";
import ProjectEditDiscardModalContent from "./ProjectEditDiscardModalContent";
import { edit, fetch as fetchProject } from "../projectActions";
import { validateProjectDetails } from "../shared/ValidateProjectDetails";
import ProjectEditContainer from "./ProjectEditContainer";
import { selectUserRoles } from "../../login/loginSelector";

let EditProject = ({
  isLoading,
  history,
  openConfirmModal,
  isFormDirty,
  projectId,
  resetForm,
  triggerSubmit,
  isFormInvalid,
  form,
  fetchProjectDetails,
  projectData,
  isDataFetched,
  currentFormValues,
  initialFormValues,
}) => {
  useEffect(() => {
    if (!projectData || projectData.length < 1) {
      // eslint-disable-next-line radix
      fetchProjectDetails(parseInt(projectId));
    }
  }, [projectData]);
  
  // Check if store-related fields have changed
  const storeFieldsChanged = currentFormValues && initialFormValues && (
    currentFormValues.store_nbr !== initialFormValues.store_nbr ||
    currentFormValues.jde_company_nbr !== initialFormValues.jde_company_nbr
  );
  
  // Disable save if store fields changed but data hasn't been fetched
  const storeDetailsNeedsFetch = storeFieldsChanged && !isDataFetched;
  
  const onCancel = () => {
    resetForm();
    history.replace(`/projects/${projectId}`);
  };
  const onClose = () => {
    if (isFormDirty) {
      openConfirmModal(<ProjectEditDiscardModalContent onDiscard={onCancel} />);
    } else {
      onCancel();
    }
  };
  return (
    <React.Fragment>
      <ProjectEditContainer
        projectTitle={projectData && projectData.projectDetails ? projectData.projectDetails.closing_name : ''}
        isLoading={isLoading}
        isFormDirty={isFormDirty}
        isFormInvalid={isFormInvalid}
        storeDetailsNeedsFetch={storeDetailsNeedsFetch}
        onSave={triggerSubmit}
        onCancel={onClose}>
        <ProjectDetails form={form} />
      </ProjectEditContainer>
    </React.Fragment>
  );
};
EditProject.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired,
  openConfirmModal: PropTypes.func.isRequired,
  isFormDirty: PropTypes.bool.isRequired,
  projectId: PropTypes.number.isRequired,
  resetForm: PropTypes.func.isRequired,
  triggerSubmit: PropTypes.func.isRequired,
  isFormInvalid: PropTypes.bool.isRequired,
  form: PropTypes.string.isRequired,
  fetchProjectDetails: PropTypes.func.isRequired,
  projectData: PropTypes.array.isRequired,
  isDataFetched: PropTypes.bool,
  currentFormValues: PropTypes.object,
  initialFormValues: PropTypes.object,
};
const mapStateToProps = (state, ownProps) => ({
  projectData: selectProject(state),
  isFormDirty: isDirty("projectEdit")(state),
  isFormInvalid: isInvalid("projectEdit")(state),
  projectId: _.get(ownProps, "match.params.projectId", null),
  isLoading: _.get(state, "projectDetails.request.loading", false),
  isDataFetched: _.get(state, "store.dataFetched.dataFetched", true),
  currentFormValues: getFormValues("projectEdit")(state),
  initialFormValues: mapProjectDataToUI(selectProject(state)),
  userRole: selectUserRoles(state),
});
const mapDispatchToProps = (dispatch, ownProps) => ({
  openConfirmModal: body => dispatch(modalActions.openModal({ body })),
  resetForm: () => dispatch(reset("projectEdit")),
  triggerSubmit: () => dispatch(edit(ownProps.history)),
  fetchProjectDetails: closingId => dispatch(fetchProject(closingId)),
});

EditProject = connect(mapStateToProps, mapDispatchToProps)(EditProject);
export default connect(
  state => ({
    initialValues: mapProjectDataToUI(selectProject(state)),
    userRole: selectUserRoles(state),
  }),
  null,
)(
  reduxForm({
    form: "projectEdit",
    validate: validateProjectDetails,
    destroyOnUnmount: false,
    enableReinitialize: true,
    onSubmitFail: () => {
      window.scrollTo(0, 0);
    },
  })(EditProject),
);
